import Cookies from "js-cookie";
import { getCompanyInfo } from "@/api/main";
import { getSettings } from "@/api/settings";

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get("sidebarStatus"),
      withoutAnimation: false,
    },
    device: "desktop",
    language: Cookies.get("language") || "en",
    company: {},
    portal: {},
    settings: {},
  },
  mutations: {
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set("sidebarStatus", 1);
      } else {
        Cookies.set("sidebarStatus", 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },
    SET_SIDEBAR_STATE: (state, opened) => {
      Cookies.set("sidebarStatus", opened ? 1 : 0);
      state.sidebar.opened = opened;
      state.sidebar.withoutAnimation = false;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set("sidebarStatus", 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Cookies.set("language", language);
    },
    SET_COMPANY: (state, company) => {
      state.company = company;
    },
    SET_PORTAL: (state, portal) => {
      state.portal = portal;
    },
    SET_SETTINGS: (state, settings) => {
      state.settings = settings;
    },
  },
  actions: {
    toggleSideBar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    setSideBarState({ commit }, opened) {
      commit("SET_SIDEBAR_STATE", opened);
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation);
    },
    toggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device);
    },
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    async initApp({ commit, dispatch }) {
      let settings;
      try {
        const response = await getSettings();
        commit("SET_SETTINGS", response.data);
        settings = response.data;
      } catch (e) {
        console.error("Unable to load settings", e);
        return;
      }
      let slug = null;

      const isWhitelabel =
        settings.whitelabel &&
        window.location.hostname.endsWith(settings.whitelabel.fqdn);
      if (
        window.location.hostname.endsWith("siscompliance.com.br") ||
        window.location.hostname.endsWith("localhost") ||
        isWhitelabel
      ) {
        // check for path based access
        slug = window.location.pathname
          .replace("/portal/", "")
          .replace(/\/+/g, "");

        // check for subdomain based access
        if (slug === "") {
          if (isWhitelabel) {
            slug = settings.whitelabel.id;
          } else {
            slug = window.location.hostname.substring(
              0,
              window.location.hostname.indexOf(".")
            );
          }
        }

        // Only load classifications if slug is valid
        if (slug && slug !== "localhost") {
          await dispatch("RefreshCompanyClassifications", slug);
        }

        return new Promise((resolve, reject) => {
          getCompanyInfo(slug)
            .then((response) => {
              const { company, portal } = response.data;
              commit("SET_COMPANY", company);
              commit("SET_PORTAL", portal);

              // Load classifications after portal is loaded
              if (portal && portal.slug) {
                dispatch("RefreshCompanyClassifications", portal.slug);
              }

              resolve();
            })
            .catch(reject);
        });
      } else {
        // fetch slug from domain
        const { company, portal } = (await getCompanyInfo()).data;

        await dispatch("RefreshCompanyClassifications", portal.slug);

        commit("SET_COMPANY", company);
        commit("SET_PORTAL", portal);
      }
    },
  },
};

export default app;
